<template>
  <div v-loading="loading">
    <div class="flex-between">
      <div class="title">作业批改（实战营）</div>
      <el-button style="height: 100%" size="small" @click="goBack"
        >返回列表</el-button
      >
    </div>
    <el-card shadow="hover">
      <div slot="header">
        <span class="brand-color">项目简介</span>
      </div>
      <div class="flex">
        <div class="flex-item">
          <span class="flex-label">项目名称：</span>
          <span>{{ projectInfo.name }}</span>
        </div>
        <div class="flex-item">
          <span class="flex-label">批改价格：</span>
          <span>¥{{ projectInfo.evaluate_price }}</span>
        </div>
      </div>
      <div class="flex">
        <div class="flex-label flex-none">批改要点：</div>
        <div class="pre-content">{{ projectInfo.evaluate_points }}</div>
      </div>
    </el-card>
    <el-card shadow="hover" class="homework-info-card">
      <div slot="header">
        <span class="brand-color">作业信息</span>
      </div>
      <div class="flex">
        <div class="flex-item">
          <span class="flex-label">作业编号：</span>
          <span>{{ homeworkInfo.id }}</span>
        </div>
        <div class="flex-item">
          <span class="flex-label">学员：</span>
          <span>{{ homeworkInfo.name }}</span>
        </div>
      </div>
      <div class="flex">
        <div class="flex-item">
          <span class="flex-label">花费时间：</span>
          <span>{{ homeworkInfo.spend_time }} 小时</span>
        </div>
        <div class="flex-item">
          <span class="flex-label">提交次数：</span>
          <span>第 {{ homeworkInfo.times }} 次提交</span>
        </div>
      </div>
      <div class="flex">
        <div class="flex-item">
          <span class="flex-label">自我评价：</span>
          <el-rate
            class="homework-info-card-rate"
            v-model="homeworkInfo.self_evaluation"
            disabled
          ></el-rate>
        </div>
        <div class="flex-item">
          <span class="flex-label">项目文件：</span>
          <el-link
            v-if="homeworkInfo.file.path"
            class="homework-info-card-link"
            :href="homeworkInfo.file.path"
            target="_blank"
            :download="homeworkInfo.file.name"
            :name="homeworkInfo.file.name"
            type="primary"
            icon="el-icon-link"
            >{{ homeworkInfo.file.name }}
          </el-link>
          <span v-else>没有文件</span>
        </div>
      </div>
      <div class="flex">
        <div class="flex-label flex-none">自我总结：</div>
        <div class="pre-content">{{ homeworkInfo.self_summary }}</div>
      </div>
      <div class="flex">
        <div class="flex-label flex-none">作业备注：</div>
        <div class="pre-content">{{ homeworkInfo.speak_to_teacher }}</div>
      </div>
    </el-card>
    <el-card shadow="hover" class="correct-card">
      <div slot="header" class="flex-between">
        <span class="brand-color">老师批改</span>
        <div>
          <el-button size="mini" @click="reference">批改范文</el-button>
        </div>
      </div>
      <div class="correct-score-container">
        总分：
        <span class="correct-score danger-color">{{ totalScore }}</span>
      </div>
      <el-form
        class="correct-info"
        label-width="110px"
        :model="correctInfo"
        :rules="correctRules"
        ref="correctInfo"
      >
        <el-form-item label="结果分：" prop="resultScore" :show-message="false">
          <zhu-slider
            class="w-95pc"
            :slider.sync="correctInfo.resultScore"
            :disabled="!correcting"
          ></zhu-slider>
        </el-form-item>
        <el-form-item label="稳定性：" prop="stability" :show-message="false">
          <zhu-slider
            class="w-95pc"
            :slider.sync="correctInfo.stability"
            :disabled="!correcting"
          ></zhu-slider>
        </el-form-item>
        <el-form-item
          label="思路分："
          prop="mentalityScore"
          :show-message="false"
        >
          <zhu-slider
            class="w-95pc"
            :slider.sync="correctInfo.mentalityScore"
            :disabled="!correcting"
          ></zhu-slider>
        </el-form-item>
        <el-form-item
          label="结构和逻辑："
          prop="structuralLogic"
          :show-message="false"
        >
          <zhu-slider
            class="w-95pc"
            :slider.sync="correctInfo.structuralLogic"
            :disabled="!correcting"
          ></zhu-slider>
        </el-form-item>
        <el-form-item
          label="代码规范性："
          prop="normalization"
          :show-message="false"
        >
          <zhu-slider
            class="w-95pc"
            :slider.sync="correctInfo.normalization"
            :disabled="!correcting"
          ></zhu-slider>
        </el-form-item>
        <el-form-item label="点评：" prop="review" :show-message="false">
          <Markdown
            class="w-95pc"
            :option="correcting ? 'all' : 'readmodel'"
            :value.sync="correctInfo.review"
            :defaultOpen="correcting ? 'edit' : 'preview'"
            placeholder="请输入评价"
            :disabled="correcting ? false : true"
            space="_for_fuwu_sub_project"
            folder="fuwu"
          ></Markdown>
        </el-form-item>
        <el-form-item
          label="批改用时："
          prop="correctTime"
          :show-message="false"
        >
          <el-input
            v-if="correcting"
            class="w-120"
            v-model="correctInfo.correctTime"
            placeholder="请输入数字"
            clearable
          ></el-input>
          <span v-else>{{ correctInfo.correctTime }}</span>
          分钟
        </el-form-item>
        <el-form-item label="审阅视频：">
          <el-button
            v-if="!correcting"
            size="medium"
            plain
            icon="el-icon-view"
            @click="showVideo"
            :disabled="!correctInfo.reviewVideo"
            >查看</el-button
          >
          <template v-else>
            <el-upload
              class="upload-video"
              action=""
              :before-upload="handleBeforeUpload"
              :disabled="uploadBtnLoading"
            >
              <el-button
                size="medium"
                plain
                icon="el-icon-upload"
                :loading="uploadBtnLoading"
                >上传</el-button
              >
            </el-upload>
            <el-link
              v-if="correctInfo.reviewVideo"
              :href="correctInfo.reviewVideo"
              target="_blank"
              type="primary"
              :underline="false"
              icon="el-icon-link"
              >{{ correctInfo.reviewVideoName }}
            </el-link>
          </template>
        </el-form-item>
      </el-form>
      <div class="submit-btn" v-show="correcting">
        <zhu-button
          v-if="
            authPermissions.includes(
              'expert_service.api.fuwu_admin.homeworks.evaluate'
            )
          "
          text="提交"
          :shadow="true"
          type="primary"
          @click="submitHomework"
          :loading="btnLoading"
        ></zhu-button>
      </div>
      <zhu-button
        v-if="
          authPermissions.includes(
            'expert_service.api.fuwu_admin.homeworks.prepare_next'
          )
        "
        zhu-class="zhu-btn-plain zhu-btn-round"
        text="下一份"
        plain
        round
        :loading="nextBtnLoading"
        icon="el-icon-right"
        @click="nextHomework"
      >
      </zhu-button>
    </el-card>
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import { mapState } from "vuex";
import API from "@/global/request/api";
import Markdown from "@/components/Markdown";
import ZhuSlider from "@/components/ZhuSlider.vue";
import qiniuService from "@/global/service/qiniu";
import homeworkService from "@/global/service/homework";

export default {
  components: {
    Markdown,
    ZhuSlider
  },
  data() {
    return {
      loading: true,
      uploadBtnLoading: false,
      btnLoading: false,
      nextBtnLoading: false,
      projectId: null,
      sourceId: null,
      correcting: true,
      bucket: "",
      projectInfo: {
        name: "无",
        evaluate_price: "0",
        evaluate_points: "无"
      },
      homeworkInfo: {
        id: null,
        name: "",
        spend_time: "0.00",
        times: "0",
        self_evaluation: 0,
        file: {
          name: "",
          path: ""
        },
        self_summary: "无",
        speak_to_teacher: "无"
      },
      correctInfo: {
        resultScore: 0,
        stability: 0,
        mentalityScore: 0,
        structuralLogic: 0,
        normalization: 0,
        review: "",
        correctTime: null,
        reviewVideo: null,
        reviewVideoId: null,
        reviewVideoName: null
      },
      correctRules: {
        resultScore: { required: true, trigger: "blur" },
        stability: { required: true, trigger: "blur" },
        mentalityScore: { required: true, trigger: "blur" },
        structuralLogic: { required: true, trigger: "blur" },
        normalization: { required: true, trigger: "blur" },
        review: { required: true, trigger: "blur" },
        correctTime: { required: true, trigger: "blur" }
      }
    };
  },
  computed: {
    ...mapState(["authPermissions"]),
    totalScore() {
      return (
        (this.correctInfo.resultScore +
          this.correctInfo.stability +
          this.correctInfo.mentalityScore +
          this.correctInfo.structuralLogic +
          this.correctInfo.normalization) /
        5
      );
    }
  },
  created() {
    this.getData();
  },
  watch: {
    $route: "getData"
  },
  methods: {
    getData() {
      const id = this.$route.params.id;
      this.loading = true;
      homeworkService.plusShow(id).then(res => {
        this.projectId = res.project_id;
        this.sourceId = res.source_company_id;
        this.correcting = res.homework_status === 1 ? true : false;
        this.bucket = res.source_company_id ? "one-assets" : "";
        homeworkService
          .plusProjectInfo(res.project_id)
          .then(projectInfo => {
            this.projectInfo = projectInfo;
            this.homeworkInfo.id = res.id;
            this.homeworkInfo.name = res.user
              ? res.user.realname || res.user.name
              : "无";
            this.homeworkInfo.spend_time = res.spend_time
              ? res.spend_time
              : "0.00";
            this.homeworkInfo.times = res.times ? res.times : "0";
            this.homeworkInfo.self_evaluation = res.self_evaluation
              ? 6 - res.self_evaluation
              : 0;
            this.homeworkInfo.file = res.file
              ? res.file
              : { name: "", path: "" };
            this.homeworkInfo.self_summary = res.self_summary
              ? res.self_summary
              : "无";
            this.homeworkInfo.speak_to_teacher = res.speak_to_teacher
              ? res.speak_to_teacher
              : "无";
            this.correctInfo.resultScore = res.level_detail
              ? res.level_detail.result * 5
              : 0;
            this.correctInfo.stability = res.level_detail
              ? res.level_detail.stability * 5
              : 0;
            this.correctInfo.mentalityScore = res.level_detail
              ? res.level_detail.thinking * 5
              : 0;
            this.correctInfo.structuralLogic = res.level_detail
              ? res.level_detail.logic * 5
              : 0;
            this.correctInfo.normalization = res.level_detail
              ? res.level_detail.normalization * 5
              : 0;
            this.correctInfo.review = res.teacher_comment
              ? res.teacher_comment
              : "";
            this.correctInfo.correctTime = res.evaluate_spend_time;
            this.correctInfo.reviewVideo = res.evaluate_file
              ? res.evaluate_file.path
              : null;
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    goBack() {
      this.$router.push({
        name: "HomeWorkPlusMySelf"
      });
    },
    reference() {
      window.open("https://shimo.im/docs/okiiKBeR3qA3oPMa");
    },
    showVideo() {
      window.open(this.correctInfo.reviewVideo);
    },
    handleBeforeUpload(file) {
      if (!file || this.uploadBtnLoading) {
        return false;
      }
      const bucket = this.bucket;
      const space = "_for_homework_sub_project";
      const folder = "fuwu";
      const api = API.homeworkQiniuVideo;
      this.uploadBtnLoading = true;
      qiniuService
        .upload({ bucket, space, folder, file, api }, () => {})
        .then(res => {
          this.correctInfo.reviewVideo = res.url;
          this.correctInfo.reviewVideoId = res.id;
          this.correctInfo.reviewVideoName = res.name;
        })
        .finally(() => {
          this.uploadBtnLoading = false;
        });
      return false;
    },
    submitHomework() {
      this.$refs["correctInfo"].validate(val => {
        const result = this.correctInfo.resultScore / 5;
        const stability = this.correctInfo.stability / 5;
        const thinking = this.correctInfo.mentalityScore / 5;
        const logic = this.correctInfo.structuralLogic / 5;
        const normalization = this.correctInfo.normalization / 5;
        if (!result || !stability || !thinking || !logic || !normalization) {
          this.$message.error("请确保每一项都有打分，且分数不能为零！");
          return;
        }
        if (!val) {
          this.$message.error("缺少必要参数");
          return;
        }
        let id = this.$route.params.id;
        let params = {
          result,
          stability,
          thinking,
          logic,
          normalization,
          teacher_comment: this.correctInfo.review,
          evaluate_spend_time: this.correctInfo.correctTime,
          evaluate_file_id: this.correctInfo.reviewVideoId
        };
        this.btnLoading = true;
        homeworkService
          .plusCorrect(id, params)
          .then(() => {
            this.$message.success("提交成功");
            this.correcting = false;
          })
          .finally(() => {
            this.btnLoading = false;
          });
      });
    },
    nextHomework() {
      if (this.nextBtnLoading || this.loading) return;
      const params = {
        project_id: this.projectId,
        company_id: this.sourceId
      };
      this.nextBtnLoading = true;
      homeworkService
        .plusNext(params)
        .then(res => {
          if (res) {
            this.$router.push({
              name: "HomeworkPlusMyDetail",
              params: { id: res.homework_id }
            });
          } else {
            this.$notify({
              title: "提示",
              message: "暂无更多同项目作业",
              type: "warning"
            });
          }
        })
        .finally(() => {
          this.nextBtnLoading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.pre-content {
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-all;
  word-wrap: break-word;
}
.el-form-item {
  margin-bottom: 48px !important;
}
.el-slider {
  line-height: 20px;
}
.flex {
  display: flex;
  margin-bottom: 12px;
  font-size: 14px;
  .flex-item {
    flex: 1;
  }
  .flex-none {
    flex: none;
  }
  .flex-label {
    display: inline-block;
    width: 70px;
    text-align: right;
  }
}
.homework-info-card {
  margin: 30px 0;
  .homework-info-card-rate {
    display: inline-block;
    line-height: 14px;
  }
  .homework-info-card-link {
    padding-bottom: 4px;
  }
}
.correct-card {
  position: relative;
  .correct-score-container {
    padding: 0 20px;
    width: 100%;
    text-align: right;
    .correct-score {
      font-size: 60px;
    }
  }
  .correct-info {
    margin-top: 20px;
    .upload-video {
      display: inline-block;
      margin-right: 16px;
    }
  }
  .submit-btn {
    margin-bottom: 30px;
    text-align: center;
    .el-button {
      width: 200px;
    }
  }
  .zhu-btn-plain.zhu-btn-round {
    position: absolute;
    bottom: 24px;
    right: 24px;
  }
}
</style>
